import { render, staticRenderFns } from "./AwardsActionsCell.vue?vue&type=template&id=745a10c8"
import script from "./AwardsActionsCell.vue?vue&type=script&lang=js"
export * from "./AwardsActionsCell.vue?vue&type=script&lang=js"
import style0 from "./AwardsActionsCell.vue?vue&type=style&index=0&id=745a10c8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports